<div class="table-fms" [formGroup]="budgetForm">
  <table>
    <thead>
    <tr class="full-sticky-group">
      <th class="col-first-level"></th>
      <th class="col-second-level"></th>
      <th class="col-third-level"></th>
      <th class="col-fourth-level">
        <div class="flex items-center justify-between justify-end">
          <span class="relative right-[5.5rem]">Budget</span>
          <div class="flex items-center">
            <app-button
              data-qa="bm-table-bttn-show-all-quarters"
              class="expand-collapse-button left"
              [size]="'xxsmall'"
              [bordersSquaredShape]="'full'"
              [type]="isAllQuartersCollapsed ? 'grey' : 'grey-accent'"
              (buttonClick)="isAllQuartersCollapsed = false; toggleAllQuarters()">
              Quarters
            </app-button>
            <app-button
              data-qa="bm-table-bttn-show-all-years"
              class="expand-collapse-button right"
              [size]="'xxsmall'"
              [bordersSquaredShape]="'full'"
              [type]="isAllQuartersCollapsed ? 'grey-accent' : 'grey'"
              (buttonClick)="isAllQuartersCollapsed = true; toggleAllQuarters()">
              Years
            </app-button>
          </div>
        </div>
      </th>
      <th class="blank-space col-fifth-level"></th>
      <ng-container *ngFor="let p of budgetForm.value.modelHeaders; let last = last">
        <ng-container *ngIf="p.type === BmPeriodEnum.YEAR">
          <th class="fix-w-5p5" [class.bg-black-4]="!(isAllQuartersCollapsed && collapsedYears.includes(p.yearNumber))">
            <div class="flex items-center justify-between">
              <span>{{ p.headerText }}</span>
              <app-all-icons
                class="cursor-pointer"
                [iconNameAndStyling]="collapsedYears.includes(p.yearNumber) ? 'arrow-right.svg' : 'arrow-left.svg'"
                [attr.data-qa]="'bm-collapse-' + p.yearNumber"
                (click)="toggleQuartersInSelectedYear(p.yearNumber)">
              </app-all-icons>
            </div>
          </th>

          <!-- thin spacer after each year, except last -->
          <th *ngIf="!last" class="fix-w-0p25 blank-space" [hidden]="isAllQuartersCollapsed && collapsedYears.includes(p.yearNumber)"></th>
        </ng-container>

        <ng-container *ngIf="p.type === BmPeriodEnum.QUARTER">
          <th
            class="fix-w-5p5"
            [hidden]="p.isCollapsed">
            {{ p.headerText }}
          </th>
        </ng-container>
      </ng-container>

      <th [class.bg-black-4]="!isAllQuartersCollapsed"></th>
      <th class="fix-w-0p25 blank-space right-sticky right-[12.2rem]"></th>
      <th class="fix-w-5p5 right-sticky right-[6.1rem]">Total</th>
      <th class="fix-w-5p5 right-sticky right-0">Total, %</th>
    </tr>
    </thead>
    <tbody>

    <!-- Mgm Section   -->
    <tr class="total two-columns-group-sticky">
      <td class="col-first-level">
        <app-table-group-icon data-qa="bm-hide-mgm-section" [formControl]="budgetForm.controls.modelData.controls.mgmFee.controls.showSection"/>
      </td>
      <td class="col-second-level" colspan="3">
        <div class="flex justify-between items-center">
          <div>Management fees</div>
          <app-button
            *ngIf="budgetForm.value.isEditState"
            data-qa="bm-add-button-mgm"
            [size]="'xxsmall'"
            [type]="'grey-accent'"
            [iconName]="'plus.svg'"
            (buttonClick)="onMgmFeeGroupAction(BmGroupAction.ADD)">Group
          </app-button>
        </div>
      </td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.mgmFee.controls.total.controls; let last = last">
        <td
          [attr.data-qa]="'bm-mgm-total-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
          class="bold600"
          [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
          [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
          {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>

      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td data-qa="bm-mgm-total-row" class="right-sticky right-[6.1rem] bold600">{{budgetForm.controls.modelData.controls.mgmFee.controls.totalRow.value | switcherDashBraces : 1 : 0 }}</td>
      <td data-qa="bm-mgm-total-row-pcnt" class="right-sticky right-0 bold600">{{budgetForm.controls.modelData.controls.mgmFee.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}</td>
    </tr>

    <ng-container *ngIf="budgetForm.controls.modelData.controls.mgmFee.controls.showSection.value">
      <!-- Mgm fee   -->
      <ng-container *ngFor="let groupControl of budgetForm.controls.modelData.controls.mgmFee.controls.groups.controls; let g = index">
        <tr class="three-columns-group-sticky">
          <td class="col-first-level">
            <app-three-dots-menu *ngIf="budgetForm.value.isEditState" [matMenuTriggerFor]="budgetForm.value.isEditState ? menu : null">
              <mat-menu #menu="matMenu">
                <ul class="list">
                  <app-drop-down-item
                    class="w-full"
                    [attr.data-qa]="'bm-mgm-rename-gr' + groupControl.getRawValue().name"
                    [text]="'Rename'"
                    [iconNameAndStyling]="'edit.svg'"
                    (click)="onMgmFeeGroupAction(BmGroupAction.RENAME, groupControl)">
                  </app-drop-down-item>
                  <app-drop-down-item
                    class="w-full"
                    [attr.data-qa]="'bm-mgm-duplicate-gr' + groupControl.getRawValue().name"
                    [text]="'Duplicate'"
                    [iconNameAndStyling]="'copy.svg'"
                    (click)="onMgmFeeGroupAction(BmGroupAction.DUPLICATE, groupControl)">
                  </app-drop-down-item>
                  <app-drop-down-item
                    class="w-full"
                    [attr.data-qa]="'bm-mgm-delete-gr' + groupControl.getRawValue().name"
                    [text]="'Delete'"
                    [menuItemClass]="'red'"
                    [iconNameAndStyling]="'delete.svg'"
                    (click)="onMgmFeeGroupAction(BmGroupAction.DELETE, groupControl)">
                  </app-drop-down-item>
                </ul>
              </mat-menu>
            </app-three-dots-menu>
          </td>
          <td class="col-second-level">
            <app-table-group-icon
              [attr.data-qa]="'bm-mgm-hide-group-' + groupControl.getRawValue().name"
              [formControl]="groupControl.controls.showGroup">
            </app-table-group-icon>
          </td>
          @if(groupControl.value.isRenameMode) {
            <td class="col-third-level" colspan="2">
              <app-input
                [attr.data-qa]="'bm-mgm-group-rename-input-' + groupControl.getRawValue().name"
                [formControl]="groupControl.controls.name"
                [suffixFirstIcon]="'close.svg; black-9'"
                [suffixSecondIcon]="groupControl.controls.name.invalid ? '' : 'check.svg; main-8'"
                [additionalClass]="groupControl.controls.name.invalid ? 'error' : ''"
                (suffixFirstIconEmitter)="onMgmFeeGroupAction(BmGroupAction.RENAME_CANCEL, groupControl)"
                (suffixSecondIconEmitter)="onMgmFeeGroupAction(BmGroupAction.RENAME_SAVE, groupControl)">
              </app-input>
            </td>
          } @else {
            <td
              [attr.data-qa]="'bm-mgm-group-name-' + groupControl.getRawValue().name"
              class="bold500 col-third-level"
              colspan="2">
              {{ groupControl.getRawValue().name }}
            </td>
          }
          <td class="blank-space col-fifth-level"></td>
          <ng-container *ngFor="let dataControl of groupControl.controls.total.controls; let last = last">
            <td
              [attr.data-qa]="'bm-mgm-group-total-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="bold600">
              {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
          <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
          <td class="blank-space right-sticky right-[12.2rem]"></td>
          <td
            [attr.data-qa]="'bm-mgm-group-total-row-' + groupControl.value.name"
            class="right-sticky right-[6.1rem] bold600">
            {{groupControl.controls.totalRow.value | switcherDashBraces : 1 : 0 }}
          </td>
          <td
            [attr.data-qa]="'bm-mgm-group-total-row-pcnt' + groupControl.value.name"
            class="right-sticky right-0 bold600">
            {{groupControl.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
          </td>
        </tr>
        <ng-container *ngIf="groupControl.controls.showGroup.value">
          <!-- Commitment -->
          <tr appOnHover #commitment_tr="onHover" class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>
            @if(budgetForm.value.isEditState) {
              <td class="col-third-level" colspan="2">
                <div class="flex items-center justify-between !pl-[0.8rem]">
                  <span>Commitment</span>
                  <app-input
                    [attr.data-qa]="'bm-mgm-commitment-std-val-' + groupControl.getRawValue().name"
                    class="w-5.625"
                    [formControl]="groupControl.controls.subGroups.controls.commitment.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [separator]="'separator.0'">
                  </app-input>
                </div>
              </td>
              <td class="blank-space col-fifth-level"></td>
              <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.commitment.controls.items.controls; let last = last">
                <td
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  <app-input
                    [attr.data-qa]="'bm-mgm-commitment-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                    [formControl]="dataControl.controls.itemValue"
                    [thousandSeparator]="','"
                    [separator]="'separator.0'"
                    [isShrinked]="true"
                    [suffixFirstIcon]="dataControl.value.period.type === BmPeriodEnum.YEAR ? '' : (dataControl.controls.itemValue.disabled ? (commitment_tr.hovered ? 'edit.svg' : '') : 'close.svg')"
                    (suffixFirstIconEmitter)="editItemValue(dataControl)">
                  </app-input>
                </td>
                <td
                  *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                  [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                  class="blank-space">
                </td>
              </ng-container>
            }
            @else {
              <td class="col-third-level !pl-[0.8rem]" colspan="2">Commitment</td>
              <td class="blank-space col-fifth-level"></td>
              <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.commitment.controls.items.controls; let last = last">
                <td
                  [attr.data-qa]="'bm-mgm-commitment-val' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))">
                  {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
                </td>
                <td
                  *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                  [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                  class="blank-space">
                </td>
              </ng-container>
            }
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td class="right-sticky right-[6.1rem]"></td>
            <td class="right-sticky right-0"></td>
          </tr>

          <!-- Management fees, % -->
          <tr appOnHover #mgm_fee_pcnt_tr="onHover" class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>

            @if(budgetForm.value.isEditState) {
              <td class="col-third-level" colspan="2">
                <div class="flex items-center justify-between !pl-[0.8rem]">
                  <span>Management fees, %</span>
                  <app-input
                    [attr.data-qa]="'bm-mgm-mgm-pcnt-std-val-' + groupControl.getRawValue().name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [additionalClass]="groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.standardValue.invalid ? 'error' : ''"
                    [separator]="'separator.2'">
                  </app-input>
                </div>
              </td>
              <td class="blank-space col-fifth-level"></td>
              <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.items.controls; let last = last">
                <td
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  <app-input
                    [attr.data-qa]="'bm-mgm-mgm-pcnt' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                    [formControl]="dataControl.controls.itemValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [separator]="'separator.2'"
                    [suffixFirstIcon]="dataControl.controls.itemValue.disabled ? (mgm_fee_pcnt_tr.hovered ? 'edit.svg' : '') : 'close.svg'"
                    (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.MGM_FEE_PCNT)">
                  </app-input>
                </td>
                <td
                  *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                  [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                  class="blank-space">
                </td>
              </ng-container>
            }
            @else {
              <td class="col-third-level !pl-[0.8rem]" colspan="2">Management fees, %</td>
              <td class="blank-space col-fifth-level"></td>
              <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.items.controls; let last = last">
                <td
                  [attr.data-qa]="'bm-mgm-mgm-pcnt-val' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 2: false : '' : '%' }}
                </td>
                <td
                  *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                  [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                  class="blank-space">
                </td>
              </ng-container>
            }
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td class="right-sticky right-[6.1rem]"></td>
            <td class="right-sticky right-0"></td>
          </tr>

          <!-- % discount -->
          <tr *ngIf="(budgetForm.value.isEditState || groupControl.value.subGroups.pcntOfMgmFees.isSelected)"
            appOnHover #pcnt_of_mgm_fee_tr="onHover" class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>
            <!--  % discount - ROW NAME -->
            @if(budgetForm.value.isEditState) {
              <td class="col-third-level" colspan="2">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-0.15625 !pl-[0.3rem]">
                    <app-checkbox
                      [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-selected-' + groupControl.getRawValue().name"
                      [formControl]="groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.isSelected">
                    </app-checkbox>
                    <span>% Discount</span>
                  </div>
                  <app-input
                    *ngIf="groupControl.value.subGroups.pcntOfMgmFees.isSelected"
                    [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-std-val-' + groupControl.getRawValue().name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [additionalClass]="groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.standardValue.invalid ? 'error' : ''"
                    [separator]="'separator.2'">
                  </app-input>
                </div>
              </td>
            }
            @else {
              <td class="col-third-level !pl-[0.8rem]" colspan="2">% Discount</td>
            }
            <td class="blank-space col-fifth-level"></td>

            <!--  % Discount - ROW VALUES -->
            <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.items.controls; let last = last">
              <!--  % Discount - ROW VALUES - EDIT STATE + SELECTED-->
              @if(budgetForm.value.isEditState && groupControl.value.subGroups.pcntOfMgmFees.isSelected){
                <td
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  <app-input
                    [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                    [formControl]="dataControl.controls.itemValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [separator]="'separator.1'"
                    [suffixFirstIcon]="dataControl.value.period.type === BmPeriodEnum.YEAR ? '' : (dataControl.controls.itemValue.disabled ? (pcnt_of_mgm_fee_tr.hovered ? 'edit.svg' : '') : 'close.svg')"
                    (suffixFirstIconEmitter)="editItemValue(dataControl)">
                  </app-input>
                </td>
              }

              <!--  % Discount - ROW VALUES - EDIT STATE + NOT SELECTED-->
              @if(budgetForm.value.isEditState && !groupControl.value.subGroups.pcntOfMgmFees.isSelected){
                <td
                  [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                </td>
              }

              <!--  % Discount - ROW VALUES - NOT EDIT STATE + SELECTED-->
              @if(!budgetForm.value.isEditState && groupControl.value.subGroups.pcntOfMgmFees.isSelected){
                <td
                  [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 1: false : '' : '%' }}
                </td>
              }
              <td
                *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                class="blank-space">
              </td>
            </ng-container>

            <!--  % Discount - ROW TOTAL VALUES -->
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td class="right-sticky right-[6.1rem]"></td>
            <td class="right-sticky right-0"></td>
          </tr>

          <!-- Management fees -->
          <tr class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>
            <td class="col-third-level !pl-[0.8rem]" colspan="2">Management fees</td>
            <td class="blank-space col-fifth-level"></td>
            <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.mgmFeeValues.controls.items.controls; let last = last">
              <td
                [attr.data-qa]="'bm-mgm-mgm-fee-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                {{ dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
              </td>
              <td
                *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                class="blank-space">
              </td>
            </ng-container>
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td class="right-sticky right-[6.1rem]">{{groupControl.controls.subGroups.controls.mgmFeeValues.controls.totalRow.value | switcherDashBraces : 1 : 0 }}</td>
            <td class="right-sticky right-0">{{groupControl.controls.subGroups.controls.mgmFeeValues.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}</td>
          </tr>

          <!-- Catch-up -->
          <tr *ngIf="(budgetForm.value.isEditState || groupControl.value.subGroups.catchUp.isSelected) && groupControl.value.subGroups.commitment.isCatchUpAvailable"
              class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>
            <!--  Catch-up - ROW NAME -->
            @if(budgetForm.value.isEditState) {
              <td class="col-third-level" colspan="2">
                <div class="flex items-center gap-0.15625 !pl-[0.3rem]">
                  <app-checkbox
                    [attr.data-qa]="'bm-mgm-catch-up-selected-' + groupControl.getRawValue().name"
                    [formControl]="groupControl.controls.subGroups.controls.catchUp.controls.isSelected">
                  </app-checkbox>
                  <span>Catch-up</span>
                </div>
              </td>
            } @else {
              <td class="col-third-level !pl-[0.8rem]" colspan="2">Catch-up</td>
            }
            <td class="blank-space col-fifth-level"></td>
            <!--  Catch-up - ROW VALUES -->
            <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.catchUp.controls.items.controls; let last = last">
              @if(groupControl.controls.subGroups.controls.catchUp.controls.isSelected.value) {
                <td
                  [attr.data-qa]="'bm-mgm-catch-up-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  {{ dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
                </td>
              } @else {
                <td
                  [attr.data-qa]="'bm-mgm-catch-up-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                </td>
              }
              <td
                *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                class="blank-space">
              </td>
            </ng-container>
            <!--  Catch-up - ROW TOTAL VALUES -->
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td [attr.data-qa]="'bm-mgm-catch-up-row-' + groupControl.getRawValue().name" class="right-sticky right-[6.1rem]">
              <span *ngIf="groupControl.controls.subGroups.controls.catchUp.controls.isSelected.value">
                {{groupControl.controls.subGroups.controls.catchUp.controls.totalRow.value | switcherDashBraces : 1 : 0 }}
              </span>
            </td>
            <td [attr.data-qa]="'bm-mgm-catch-up-row-pcnt-' + groupControl.getRawValue().name" class="right-sticky right-0">
               <span *ngIf="groupControl.controls.subGroups.controls.catchUp.controls.isSelected.value">
                {{groupControl.controls.subGroups.controls.catchUp.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
              </span>
            </td>
          </tr>

          <!-- VAT, % -->
          <tr *ngIf="budgetForm.value.isEditState || groupControl.value.subGroups.vatPcnt.isSelected" appOnHover #vat_tr="onHover" class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>
          <!--  VAT, % - ROW NAME -->
            @if(budgetForm.value.isEditState) {
              <td class="col-third-level" colspan="2">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-0.15625 !pl-[0.3rem]">
                    <app-checkbox
                      [attr.data-qa]="'bm-mgm-vat-selected-' + groupControl.getRawValue().name"
                      [formControl]="groupControl.controls.subGroups.controls.vatPcnt.controls.isSelected">
                    </app-checkbox>
                    <span>VAT, %</span>
                  </div>
                  <app-input
                    *ngIf="groupControl.value.subGroups.vatPcnt.isSelected"
                    [attr.data-qa]="'bm-mgm-vat-pcnt-std-val-' + groupControl.getRawValue().name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.subGroups.controls.vatPcnt.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [additionalClass]="groupControl.controls.subGroups.controls.vatPcnt.controls.standardValue.invalid ? 'error' : ''"
                    [separator]="'separator.2'">
                  </app-input>
                </div>
              </td>
            }
            @else {
              <td class="col-third-level !pl-[0.8rem]" colspan="2">VAT, %</td>
            }
            <td class="blank-space col-fifth-level"></td>
            <!--  VAT, % - ROW VALUES -->
            <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.vatPcnt.controls.items.controls; let last = last">
              <!--  VAT, % - ROW VALUES - EDIT STATE + VAT SELECTED-->
              @if(budgetForm.value.isEditState && groupControl.value.subGroups.vatPcnt.isSelected) {
                <td
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  <app-input
                    [attr.data-qa]="'bm-mgm-vat-pcnt-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                    [formControl]="dataControl.controls.itemValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [separator]="'separator.2'"
                    [suffixFirstIcon]="dataControl.value.period.type === BmPeriodEnum.YEAR ? '' : (dataControl.controls.itemValue.disabled ? (vat_tr.hovered ? 'edit.svg' : '') : 'close.svg')"
                    (suffixFirstIconEmitter)="editItemValue(dataControl)">
                  </app-input>
                </td>
              }
              <!--  VAT, % - ROW VALUES - EDIT STATE + VAT NOT SELECTED-->
              @if (budgetForm.value.isEditState && !groupControl.value.subGroups.vatPcnt.isSelected) {
                <td
                  [attr.data-qa]="'bm-mgm-vat-pcnt-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                </td>
              }
              <!--  VAT, % - ROW VALUES - NOT EDIT STATE + VAT SELECTED-->
              @if (!budgetForm.value.isEditState && groupControl.value.subGroups.vatPcnt.isSelected) {
                <td
                  [attr.data-qa]="'bm-mgm-vat-pcnt-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                  [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                  [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                  {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 2: false : '' : '%' }}
                </td>
              }
              <td
                *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                class="blank-space">
              </td>
            </ng-container>
            <!--  VAT, % - ROW TOTAL VALUE -->
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td class="right-sticky right-[6.1rem]"></td>
            <td class="right-sticky right-0"></td>
          </tr>

          <!-- VAT -->
          <tr *ngIf="groupControl.value.subGroups.vatPcnt.isSelected" class="three-columns-group-sticky">
            <td class="col-first-level"></td>
            <td class="col-second-level"></td>
            <td class="col-third-level !pl-[0.8rem]" colspan="2">VAT</td>
            <td class="blank-space col-fifth-level"></td>
            <ng-container *ngFor="let dataControl of groupControl.controls.subGroups.controls.vatValues.controls.items.controls; let last = last">
              <td
                [attr.data-qa]="'bm-mgm-vat-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
                [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
                {{ dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
              </td>
              <td
                *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
                [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
                class="blank-space">
              </td>
            </ng-container>
            <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
            <td class="blank-space right-sticky right-[12.2rem]"></td>
            <td
              [attr.data-qa]="'bm-mgm-vat-row-' + groupControl.getRawValue().name"
              class="right-sticky right-[6.1rem]">
              {{groupControl.controls.subGroups.controls.vatValues.controls.totalRow.value | switcherDashBraces : 1 : 0 }}
            </td>
            <td
              [attr.data-qa]="'bm-mgm-vat-row-pcnt-' + groupControl.getRawValue().name"
              class="right-sticky right-0">
              {{groupControl.controls.subGroups.controls.vatValues.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </ng-container>
    </tbody>

    <!-- Operating Expenses -->
    <tbody cdkDropList (cdkDropListDropped)="changeOrderInExpensesGroup($event, budgetForm.controls.modelData.controls.operatingExpenses.controls.groups)">
    <tr class="total two-columns-group-sticky">
      <td class="col-first-level">
        <app-table-group-icon data-qa="bm-hide-opex-section" [formControl]="budgetForm.controls.modelData.controls.operatingExpenses.controls.showSection"/>
      </td>
      <td class="col-second-level" colspan="3">
        <div class="flex justify-between items-center">
          <div>Operating expenses</div>
          <app-button
            *ngIf="budgetForm.value.isEditState"
            data-qa="bm-add-button-op-exp"
            [size]="'xxsmall'"
            [type]="'grey-accent'"
            [iconName]="'plus.svg'"
            (buttonClick)="onOpExpGroupAction(BmGroupAction.ADD)">Item
          </app-button>
        </div>
      </td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.operatingExpenses.controls.total.controls; let last = last">
        <td [attr.data-qa]="'bm-op-ex-total-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
            class="bold600"
            [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
            [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
          {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>
      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td data-qa="bm-op-ex-row" class="right-sticky right-[6.1rem] bold600">{{budgetForm.controls.modelData.controls.operatingExpenses.controls.totalRow.value | switcherDashBraces : 1 : 0 }}</td>
      <td data-qa="bm-op-ex-row-pcnt" class="right-sticky right-0 bold600">{{budgetForm.controls.modelData.controls.operatingExpenses.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}</td>
    </tr>
    <ng-container
      *ngFor="let groupControl of budgetForm.controls.modelData.controls.operatingExpenses.controls.groups.controls">
      <tr
        *ngIf="budgetForm.controls.modelData.controls.operatingExpenses.controls.showSection.value"
        appOnHover #hover="onHover"
        cdkDrag
        [ngClass]="budgetForm.value.isEditState ? 'three-columns-group-sticky' : 'two-columns-group-sticky'"
        [cdkDragDisabled]="!budgetForm.value.isEditState || groupControl.value.isRenameMode">
        <td
          *ngIf="budgetForm.value.isEditState"
          class="col-first-level">
          <app-all-icons
            *ngIf="!groupControl.value.isRenameMode"
            cdkDragHandle
            [attr.data-qa]="'bm-op-ex-drag-handle-' + groupControl.getRawValue().name"
            [iconNameAndStyling]="'drop-icon.svg;drag-icon icon-size-1p375 cursor-grab'">
          </app-all-icons>
        </td>
        <td [ngClass]="budgetForm.value.isEditState ? 'col-second-level' : 'col-first-level'">
          <app-three-dots-menu *ngIf="budgetForm.value.isEditState" [matMenuTriggerFor]="budgetForm.value.isEditState ? menu : null">
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  [attr.data-qa]="'bm-op-ex-rename-gr' + groupControl.getRawValue().name"
                  class="w-full"
                  [text]="'Rename'"
                  [iconNameAndStyling]="'edit.svg'"
                  (click)="onOpExpGroupAction(BmGroupAction.RENAME, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  [attr.data-qa]="'bm-op-ex-duplicate-gr' + groupControl.getRawValue().name"
                  class="w-full"
                  [text]="'Duplicate'"
                  [iconNameAndStyling]="'copy.svg'"
                  (click)="onOpExpGroupAction(BmGroupAction.DUPLICATE, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  [attr.data-qa]="'bm-op-ex-delete-gr' + groupControl.getRawValue().name"
                  class="w-full"
                  [text]="'Delete'"
                  [menuItemClass]="'red'"
                  [iconNameAndStyling]="'delete.svg'"
                  (click)="onOpExpGroupAction(BmGroupAction.DELETE, groupControl)">
                </app-drop-down-item>
              </ul>
            </mat-menu>
          </app-three-dots-menu>
        </td>

        @if(budgetForm.value.isEditState) {
          <td [ngClass]="budgetForm.value.isEditState ? 'col-third-level' : 'col-second-level'" [attr.colspan]="budgetForm.value.isEditState ? '2' : '3'">
            <div class="flex items-center justify-between">
              @if(groupControl.value.isRenameMode) {
                <app-input
                  [attr.data-qa]="'bm-op-ex-group-rename-' + groupControl.getRawValue().name"
                  [formControl]="groupControl.controls.name"
                  [isShrinked]="true"
                  [suffixFirstIcon]="'close.svg; black-9'"
                  [suffixSecondIcon]="groupControl.controls.name.invalid ? '' : 'check.svg; main-8'"
                  [additionalClass]="groupControl.controls.name.invalid ? 'error' : ''"
                  (suffixFirstIconEmitter)="onOpExpGroupAction(BmGroupAction.RENAME_CANCEL, groupControl)"
                  (suffixSecondIconEmitter)="onOpExpGroupAction(BmGroupAction.RENAME_SAVE, groupControl)">
                </app-input>
              } @else {
                {{ groupControl.getRawValue().name }}
              }
              <div class="flex items-center gap-0.15625">
                <app-selector
                  [attr.data-qa]="'bm-op-exp-data-filling-type-' + groupControl.getRawValue().name"
                  class="w-[4.5rem]"
                  [outerClass]="'control-shrinked-container'"
                  [formControl]="groupControl.controls.dataFillingType"
                  [data]="dataFillingTypes">
                </app-selector>
                @if(groupControl.value.dataFillingType !== BmDataFillingType.MANUAL) {
                  <app-input
                    [attr.data-qa]="'bm-op-exp-data-std-val-' + groupControl.getRawValue().name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [separator]="'separator.0'">
                  </app-input>
                }
                @else {
                  <div class="w-[4rem]"></div>
                }
              </div>
            </div>
          </td>
          <td class="blank-space col-fifth-level"></td>
          <ng-container *ngFor="let dataControl of groupControl.controls.items.controls; let last = last">
            <td
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
              <app-input
                [attr.data-qa]="'bm-op-ex-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                [formControl]="dataControl.controls.itemValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
                [separator]="'separator.0'"
                [suffixFirstIcon]="dataControl.controls.itemValue.disabled ? ((hover.hover$ | async) ? 'edit.svg' : '') : 'close.svg'"
                (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.EXPENSES)">
              </app-input>
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
        }
        @else {
          <td class="col-second-level" colspan="3">{{groupControl.getRawValue().name}}</td>
          <td class="blank-space col-fifth-level"></td>
          <ng-container *ngFor="let dataControl of groupControl.controls.items.controls; let last = last">
            <td
              [attr.data-qa]="'bm-op-ex-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
              {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
        }
        <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td
          [attr.data-qa]="'bm-op-ex-val-row-' + groupControl.getRawValue().name"
          class="right-sticky right-[6.1rem]">
          {{groupControl.controls.totalRow.value | switcherDashBraces : 1 : 0}}
        </td>
        <td
          [attr.data-qa]="'bm-op-ex-val-row-pcnt-' + groupControl.getRawValue().name"
          class="right-sticky right-0">
          {{groupControl.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
        </td>
      </tr>
    </ng-container>
    </tbody>

    <!--  Organizational expenses      -->
    <tbody cdkDropList (cdkDropListDropped)="changeOrderInExpensesGroup($event, budgetForm.controls.modelData.controls.organizationalExpenses.controls.groups)">
    <tr class="total two-columns-group-sticky">
      <td class="col-first-level">
        <app-table-group-icon data-qa="bm-org-ex-hide-section" [formControl]="budgetForm.controls.modelData.controls.organizationalExpenses.controls.showSection"/>
      </td>
      <td class="col-second-level" colspan="3">
        <div class="flex justify-between items-center">
          <div>Organizational expenses</div>
          <app-button
            *ngIf="budgetForm.value.isEditState"
            data-qa="bm-add-button-org-exp"
            [size]="'xxsmall'"
            [type]="'grey-accent'"
            [iconName]="'plus.svg'"
            (buttonClick)="onOrgExpGroupAction(BmGroupAction.ADD)">Item
          </app-button>
        </div>
      </td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.organizationalExpenses.controls.total.controls; let last = last">
        <td [attr.data-qa]="'bm-org-ex-total-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
            [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
            [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)"                class="bold600">
          {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0 }}
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>

      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td data-qa="bm-org-ex-row" class="right-sticky right-[6.1rem] bold600">{{budgetForm.controls.modelData.controls.organizationalExpenses.controls.totalRow.value | switcherDashBraces : 1 : 0 }}</td>
      <td data-qa="bm-org-ex-row-pcnt" class="right-sticky right-0 bold600">{{budgetForm.controls.modelData.controls.organizationalExpenses.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}</td>
    </tr>


    <ng-container
      *ngFor="let groupControl of budgetForm.controls.modelData.controls.organizationalExpenses.controls.groups.controls">
      <tr
        *ngIf="budgetForm.value.modelData.organizationalExpenses.showSection"
        appOnHover #hover="onHover"
        cdkDrag
        [ngClass]="budgetForm.value.isEditState ? 'three-columns-group-sticky' : 'two-columns-group-sticky'"
        [cdkDragDisabled]="!budgetForm.value.isEditState || groupControl.value.isRenameMode">
        <td
          *ngIf="budgetForm.value.isEditState"
          class="col-first-level">
          <app-all-icons
            *ngIf="!groupControl.value.isRenameMode"
            cdkDragHandle
            [attr.data-qa]="'bm-org-ex-drag-handle-' + groupControl.getRawValue().name"
            [iconNameAndStyling]="'drop-icon.svg;drag-icon icon-size-1p375 cursor-grab'">
          </app-all-icons>
        </td>
        <td [ngClass]="budgetForm.value.isEditState ? 'col-second-level' : 'col-first-level'">
          <app-three-dots-menu *ngIf="budgetForm.value.isEditState" [matMenuTriggerFor]="budgetForm.value.isEditState ? menu : null">
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  class="w-full"
                  [attr.data-qa]="'bm-org-ex-rename-gr' + groupControl.getRawValue().name"
                  [text]="'Rename'"
                  [iconNameAndStyling]="'edit.svg'"
                  (click)="onOrgExpGroupAction(BmGroupAction.RENAME, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  class="w-full"
                  [attr.data-qa]="'bm-org-ex-duplicate-gr' + groupControl.getRawValue().name"
                  [text]="'Duplicate'"
                  [iconNameAndStyling]="'copy.svg'"
                  (click)="onOrgExpGroupAction(BmGroupAction.DUPLICATE, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  class="w-full"
                  [attr.data-qa]="'bm-org-ex-delete-gr' + groupControl.getRawValue().name"
                  [text]="'Delete'"
                  [menuItemClass]="'red'"
                  [iconNameAndStyling]="'delete.svg'"
                  (click)="onOrgExpGroupAction(BmGroupAction.DELETE, groupControl)">
                </app-drop-down-item>
              </ul>
            </mat-menu>
          </app-three-dots-menu>
        </td>

        @if(budgetForm.value.isEditState) {
          <td [ngClass]="budgetForm.value.isEditState ? 'col-third-level' : 'col-second-level'" [attr.colspan]="budgetForm.value.isEditState ? '2' : '3'">
            <div class="flex items-center justify-between">
              @if(groupControl.value.isRenameMode) {
                <app-input
                  [attr.data-qa]="'bm-org-ex-rename-' + groupControl.controls.name"
                  [formControl]="groupControl.controls.name"
                  [isShrinked]="true"
                  [suffixFirstIcon]="'close.svg; black-9'"
                  [suffixSecondIcon]="groupControl.controls.name.invalid ? '' : 'check.svg; main-8'"
                  [additionalClass]="groupControl.controls.name.invalid ? 'error' : ''"
                  (suffixFirstIconEmitter)="onOrgExpGroupAction(BmGroupAction.RENAME_CANCEL, groupControl)"
                  (suffixSecondIconEmitter)="onOrgExpGroupAction(BmGroupAction.RENAME_SAVE, groupControl)">
                </app-input>
              } @else {
                {{ groupControl.getRawValue().name }}
              }
              <div class="flex items-center gap-0.15625">
                <app-selector
                  [attr.data-qa]="'bm-org-ex-data-filling-type-' + groupControl.getRawValue().name"
                  class="w-[4.5rem]"
                  [outerClass]="'control-shrinked-container'"
                  [formControl]="groupControl.controls.dataFillingType"
                  [data]="dataFillingTypes">
                </app-selector>
                @if(groupControl.value.dataFillingType !== BmDataFillingType.MANUAL) {
                  <app-input
                    [attr.data-qa]="'bm-org-ex-std-val-' + groupControl.getRawValue().name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [separator]="'separator.0'">
                  </app-input>
                }
                @else {
                  <div class="w-[4rem]"></div>
                }
              </div>
            </div>
          </td>
          <td class="blank-space col-fifth-level"></td>
          <ng-container *ngFor="let dataControl of groupControl.controls.items.controls; let last = last">
            <td
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
              <app-input
                [attr.data-qa]="'bm-org-ex-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                [formControl]="dataControl.controls.itemValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
                [separator]="'separator.0'"
                [suffixFirstIcon]="dataControl.controls.itemValue.disabled ? (hover.hovered ? 'edit.svg' : '') : 'close.svg'"
                (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.EXPENSES)">
              </app-input>
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
        }
        @else {
          <td class="col-second-level" colspan="3">{{groupControl.getRawValue().name}}</td>
          <td class="blank-space col-fifth-level"></td>
          <ng-container *ngFor="let dataControl of groupControl.controls.items.controls; let last = last">
            <td
              [attr.data-qa]="'bm-org-ex-val-' + groupControl.getRawValue().name + '-' + dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
              {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
        }
        <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td
          [attr.data-qa]="'bm-org-ex-row-' + groupControl.getRawValue().name"
          class="right-sticky right-[6.1rem]">
          {{groupControl.controls.totalRow.value | switcherDashBraces : 1 : 0}}
        </td>
        <td
          [attr.data-qa]="'bm-org-ex-row-pcnt-' + groupControl.getRawValue().name"
          class="right-sticky right-0">
          {{groupControl.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
        </td>
      </tr>
    </ng-container>
    </tbody>

    <!-- Total expenses      -->
    <tbody>
    <tr class="blank-row two-columns-group-sticky">
      <td class="col-first-level"></td>
      <td class="col-second-level" colspan="3"></td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let p of budgetForm.value.modelHeaders; let last = last">
        <td *ngIf="p.type === BmPeriodEnum.QUARTER"
            [hidden]="isAllQuartersCollapsed || collapsedYears.includes(p.yearNumber)">
        </td>
        <td *ngIf="p.type === BmPeriodEnum.YEAR && !last"
            [hidden]="isAllQuartersCollapsed || collapsedYears.includes(p.yearNumber)"
            class="blank-space">
        </td>
      </ng-container>
      <td></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td class="right-sticky right-[6.1rem]"></td>
      <td class="right-sticky right-0"></td>
    </tr>
    <tr class="total two-columns-group-sticky">
      <td class="col-first-level"></td>
      <td class="col-second-level" colspan="3">Total expenses</td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.totalExpenses.controls.values.controls; let last = last">
        <td
          [attr.data-qa]="'bm-total-expenses-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
          [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
          [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="bold600">
          {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>
      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td [attr.data-qa]="'bm-total-expenses-row'" class="right-sticky right-[6.1rem] bold600">{{ budgetForm.controls.modelData.controls.totalExpenses.controls.totalRow.value | switcherDashBraces : 1 : 0}}</td>
      <td [attr.data-qa]="'bm-total-expenses-row-pcnt'" class="right-sticky right-0 bold600">{{budgetForm.controls.modelData.controls.totalExpenses.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}</td>
    </tr>
    <tr class="total two-columns-group-sticky">
      <td class="col-first-level"></td>
      <td class="col-second-level" colspan="3">Total expenses, %</td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.totalExpenses.controls.pcnt.controls; let last = last">
        <td
          [attr.data-qa]="'bm-total-expenses-pcnt-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
          [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
          [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="bold600">
          {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 1 : false :  '' : '%' }}
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>
      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td data-qa="bm-total-expenses-row" class="right-sticky right-[6.1rem] bold600"></td>
      <td class="right-sticky right-0"></td>
    </tr>
    <tr class="blank-row two-columns-group-sticky">
      <td class="col-first-level"></td>
      <td class="col-second-level" colspan="3"></td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let p of budgetForm.value.modelHeaders; let last = last">
        <td *ngIf="p.type === BmPeriodEnum.QUARTER"
            [hidden]="isAllQuartersCollapsed || collapsedYears.includes(p.yearNumber)">
        </td>
        <td *ngIf="p.type === BmPeriodEnum.YEAR && !last"
            [hidden]="isAllQuartersCollapsed || collapsedYears.includes(p.yearNumber)"
            class="blank-space">
        </td>
      </ng-container>
      <td></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td class="right-sticky right-[6.1rem]"></td>
      <td class="right-sticky right-0"></td>
    </tr>

    <!-- Investment  -->
    <tr class="bg-black-1 two-columns-group-sticky"  appOnHover #investment_tr="onHover">
      <td class="col-first-level">
        <app-table-group-icon data-qa="bm-hide-inv-section" [formControl]="budgetForm.controls.modelData.controls.investment.controls.showSection"/>
      </td>
      <td class="col-second-level" colspan="3">
        <div class="flex justify-between items-center">
          <div class="bold600">Investment</div>
          <app-input
             *ngIf="budgetForm.value.isEditState"
             data-qa="bm-inv-value"
             class="w-[8.7rem]"
             [formControl]="budgetForm.controls.modelData.controls.investment.controls.investmentValue"
             [isShrinked]="true"
             [thousandSeparator]="','"
             [separator]="'separator.0'">
          </app-input>
        </div>
      </td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.investment.controls.itemsValue.controls; let last = last">
        <td class="bold600"
            [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
            [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
          @if(dataControl.getRawValue().period.type === BmPeriodEnum.YEAR) {
            @if(budgetForm.value.isEditState) {
              <app-input
                [attr.data-qa]="'bm-inv-val-item-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                [formControl]="dataControl.controls.itemValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [separator]="'separator.0'"
                [suffixFirstIcon]="dataControl.value.period.type === BmPeriodEnum.YEAR ? (dataControl.controls.itemValue.disabled ? (investment_tr.hovered ? 'edit.svg' : ''): 'close.svg'): ''"
                (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.INVESTMENT_VALUE)">
              </app-input>
            } @else {
              <span [attr.data-qa]="'bm-inv-val-item-val'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber">
                    {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
                  </span>
            }
          } @else {
            <span [attr.data-qa]="'bm-inv-val-item-val'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber">
                    {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
                  </span>
          }
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>
      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td data-qa="bm-inv-row" class="right-sticky right-[6.1rem] bold600">{{budgetForm.controls.modelData.controls.investment.controls.totalRow.value | switcherDashBraces : 1 : 0 }}</td>
      <td data-qa="bm-inv-row-pcnt" class="right-sticky right-0 bold600">{{budgetForm.controls.modelData.controls.investment.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}</td>
    </tr>
    <tr *ngIf="budgetForm.controls.modelData.controls.investment.controls.showSection.value" appOnHover #investment_pcnt_tr="onHover" class="two-columns-group-sticky">
      <td class="col-first-level"></td>
      <td
        data-qa="bm-inv-rest-pcnt"
        class="col-second-level"
        colspan="3">Investment, % (
        {{budgetForm.value.modelData.investment.itemsPcntSum ? budgetForm.value.modelData.investment.itemsPcntSum.toFixed(2) + '%': 'out'}}
        of 100%)
      </td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container>
        @if(budgetForm.value.isEditState) {
          <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.investment.controls.itemsPcnt.controls; let last = last">
            <td
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
              <app-input
                [attr.data-qa]="'bm-inv-pcnt-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
                [formControl]="dataControl.controls.itemValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [separator]="'separator.2'"
                [suffix]="'%'"
                [suffixFirstIcon]="dataControl.value.period.type === BmPeriodEnum.YEAR ? (dataControl.controls.itemValue.disabled ? (investment_pcnt_tr.hovered ? 'edit.svg' : ''): 'close.svg'): ''"
                (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.INVESTMENT_PCNT)">
              </app-input>
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
        }
        @else {
          <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.investment.controls.itemsPcnt.controls; let last = last">
            <td
              [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)"
              [class.bg-black-2]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
              [attr.data-qa]="'bm-inv-pcnt-val-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber">
              {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 2: false : '' : '%'}}
            </td>
            <td
              *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
              class="blank-space">
            </td>
          </ng-container>
        }
        <td [class.bg-black-2]="!isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td class="right-sticky right-[6.1rem]"></td>
        <td class="right-sticky right-0"></td>
      </ng-container>
    </tr>

    </tbody>

    <tfoot class="two-columns-group-sticky">
      <tr class="total">
        <td class="col-first-level"></td>
        <td class="col-second-level" colspan="3">Total capital required</td>
        <td class="blank-space col-fifth-level"></td>
        <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.totalCapRequired.controls.values.controls; let last = last">
          <td
            [attr.data-qa]="'bm-total-cap-req-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
            class="bold600"
            [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
            [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
            {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
          </td>
          <td
            *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
            [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
            class="blank-space">
          </td>
        </ng-container>
        <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td
          [attr.data-qa]="'bm-total-cap-req-row'"
          class="right-sticky right-[6.1rem] bold600">
          {{ budgetForm.controls.modelData.controls.totalCapRequired.controls.totalRow.value | switcherDashBraces : 1 : 0}}
        </td>
        <td
          [attr.data-qa]="'bm-total-cap-req-row-pcnt'"
          class="right-sticky right-0">
          {{budgetForm.controls.modelData.controls.totalCapRequired.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
        </td>
      </tr>
      <tr class="total">
        <td class="col-first-level"></td>
        <td class="col-second-level" colspan="3">Total capital required, %</td>
        <td class="blank-space col-fifth-level"></td>
        <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.totalCapRequired.controls.pcnt.controls; let last = last">
          <td
            [attr.data-qa]="'bm-total-cap-req-pcnt-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
            class="bold600"
            [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
            [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
            {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 1: false : '' : '%' }}
          </td>
          <td
            *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
            [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
            class="blank-space">
          </td>
        </ng-container>
        <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td data-qa="bm-total-cap-req-pcnt-row" class="right-sticky right-[6.1rem] bold600">{{ budgetForm.controls.modelData.controls.totalCapRequired.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%'}}</td>
        <td class="right-sticky right-0"></td>
      </tr>
      <tr class="blank-row">
        <td class="col-first-level"></td>
        <td class="col-second-level" colspan="3"></td>
        <td class="blank-space col-fifth-level"></td>
        <ng-container *ngFor="let p of budgetForm.value.modelHeaders; let last = last">
          <td *ngIf="p.type === BmPeriodEnum.QUARTER"
              [hidden]="isAllQuartersCollapsed || collapsedYears.includes(p.yearNumber)">
          </td>
          <td *ngIf="p.type === BmPeriodEnum.YEAR && !last"
              [hidden]="isAllQuartersCollapsed || collapsedYears.includes(p.yearNumber)"
              class="blank-space">
          </td>
        </ng-container>
        <td></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td class="right-sticky right-[6.1rem]"></td>
        <td class="right-sticky right-0"></td>
      </tr>
      <tr class="total">
        <td class="col-first-level"></td>
        <td class="col-second-level" colspan="3">Accumulated capital required</td>
        <td class="blank-space col-fifth-level"></td>
        <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.totalCapAccumulated.controls.values.controls; let last = last">
          <td
            [attr.data-qa]="'bm-total-acc-req-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
            class="bold600"
            [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
            [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
            {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 0}}
          </td>
          <td
            *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
            [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
            class="blank-space">
          </td>
        </ng-container>
        <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[12.2rem]"></td>
        <td data-qa="bm-total-acc-req-row" class="right-sticky right-[6.1rem] bold600">{{ budgetForm.controls.modelData.controls.totalCapRequired.controls.totalRow.value | switcherDashBraces : 1 : 0}}</td>
        <td class="right-sticky right-0 bold600"></td>
      </tr>
      <tr class="total">
      <td class="col-first-level"></td>
      <td class="col-second-level" colspan="3">Accumulated capital required, %</td>
      <td class="blank-space col-fifth-level"></td>
      <ng-container *ngFor="let dataControl of budgetForm.controls.modelData.controls.totalCapAccumulated.controls.pcnt.controls; let last = last">
        <td
          [attr.data-qa]="'bm-total-acc-req-pcnt-'+ dataControl.value.period.quarterNumber + '-' + dataControl.value.period.yearNumber"
          class="bold600"
          [class.bg-black-3]="dataControl.value.period.type === BmPeriodEnum.YEAR && !(isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber))"
          [hidden]="dataControl.value.period.type === BmPeriodEnum.QUARTER  && collapsedYears.includes(dataControl.value.period.yearNumber)">
          {{dataControl.getRawValue().itemValue | switcherDashBraces : 1 : 1: false : '' : '%'}}
        </td>
        <td
          *ngIf="dataControl.value.period.type === BmPeriodEnum.YEAR && !last"
          [hidden]="isAllQuartersCollapsed && collapsedYears.includes(dataControl.value.period.yearNumber)"
          class="blank-space">
        </td>
      </ng-container>
      <td [class.bg-black-3]="!isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[12.2rem]"></td>
      <td data-qa="bm-total-acc-req-row" class="right-sticky right-[6.1rem]">{{ budgetForm.controls.modelData.controls.totalCapRequired.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%'}}</td>
      <td class="right-sticky right-0"></td>
    </tr>
    </tfoot>
  </table>
</div>


